import {
	DpFanCardActionButtonSx,
	DpFanCardActionDescriptionSx,
	DpFanCardActionFrameSx,
	DpFanCardActionTitleSx,
} from '@/components/blocks/DpFanCardAction/styles';
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { Img } from '@/components/blocks/MaterialImage';
import { Box, Typography } from '@mui/material';

export const DpFanCardAction = () => (
	<Box sx={DpFanCardActionFrameSx}>
		<Typography sx={DpFanCardActionTitleSx}>
			<Img src="/images/dpfan/icons/wand.svg" alt="wand" />
			{'ARMA TU PERFIL DE ESTILO'}
		</Typography>
		<Typography sx={DpFanCardActionDescriptionSx}>
			Cuéntanos tus tallas, marcas, estilos y más para personalizar tu experiencia.
			<DpButton component="a" variant="text" href="/quiz-estilo" sx={DpFanCardActionButtonSx}>
				{'Comenzar'}
			</DpButton>
		</Typography>
	</Box>
);
